export class GenericCache {
    /** @remarks Using a keyLoopupFunction makes the cache much much slower! */
    constructor(_keyLookupFunction) {
        this._keyLookupFunction = _keyLookupFunction;
        this._cache = new Map();
        this.delete = (key) => {
            return this._cache.delete(key);
        };
        this.clear = () => {
            this._cache.clear();
        };
    }
    get(key, createMissing) {
        key =
            this._keyLookupFunction === undefined
                ? key
                : this.findExistingKeyOrReturnInput(key, this._keyLookupFunction);
        let item = this._cache.get(key);
        if (item !== undefined) {
            return item;
        }
        item = createMissing();
        this._cache.set(key, item);
        return item;
    }
    /**
     * This might seem unnecessary, but for non-primitive datatypes equality is compared on
     * reference, not value, so finding the right key is a thing that must be done.
     */
    findExistingKeyOrReturnInput(key, keyLookupFunction) {
        for (const otherKey of this._cache.keys()) {
            if (keyLookupFunction(key, otherKey)) {
                return otherKey;
            }
        }
        return key;
    }
}
